import PropTypes from 'prop-types';
import React from 'react';
// libs
import Price from '../../../libs/Price';
import Product from '../../../libs/Product';
import wixArtStoreSDK from '../../../libs/wixArtStoreSDK';
import Wix from '../../../libs/Wix';
import classNames from 'classnames';
// components
import { Row, Col } from '../common/Grid';
import { Edit, Preview, Quantity, Remove } from './Elements';
import PriceLine from '../common/Blocks/PriceLine';
// styles
let MobileDetect = require('mobile-detect');
let md = new MobileDetect(Wix.mobile());
const styles = md.mobile() ? require('./scss/cart.m.scss') : require('./scss/cart.d.scss');

const Item = props => {
  const { site, item } = props;

  const price = new Price();
  price.setCurrency(site.data.currency);
  price.setFormat(site.data.priceFormat);
  price.setCurrencySide(site.data.currencySide);

  const product = new Product(item.metadata);

  const openEditor = () => {
    let urlParams = {
      imageUrl   : item.metadata.data.imageUrl,
      itemUrl    : item.metadata.data.itemUrl,
      itemWidth  : item.metadata.data.itemWidth,
      itemHeight : item.metadata.data.itemHeight,
      fpX        : item.metadata.data.fpX,
      fpY        : item.metadata.data.fpY,
      title      : item.metadata.data.title || '',
      galleryId  : item.galleryId,
      pricelistId: item.pricelistId,
      uuid       : item.uuid,
      referer    : 'cart'
    };
    wixArtStoreSDK.cart.openModal('editor',
      {
        urlPath  : `/${item.metadata.id}`,
        urlParams: urlParams
      });
  };

  const changeQuantity = (value) => {
    wixArtStoreSDK.cart.updateItem(
      item.uuid,
      {...item, quantity: parseInt(value)}
    );
  };

  return (
    <Row key={item.uuid} className={classNames(styles.cartRow, styles.category, 'border-015-description')}>

      <Col xs={3} className={styles.categoryThumbWrapper}>
        <Preview img={item.metadata.mockup} className={styles.categoryThumb}/>
      </Col>

      <Col xs={9} className={classNames(styles.itemInfo, styles.itemInfoMobile)}>

        <div className={styles.categoryTitle}>
          {product.Category()}
          <Remove action={() => wixArtStoreSDK.cart.removeItem(item.uuid) }/>
        </div>

        <div className={styles.categoryDescription}>
          <span>{product.SubCategory()} {product.Addon() ? `- ${product.Addon()}` : ''}</span>
          <Edit action={openEditor}/>
        </div>

      </Col>

      <Col xs={9} xsOffset={3} className={classNames(styles.itemInfo, styles.itemBottomMobile)}>

        <Quantity
          value={item.quantity}
          changeQuantity={(value) => changeQuantity(value)}
          increment={() => changeQuantity(item.quantity + 1)}
          decrement={() => changeQuantity(item.quantity - 1)}
        />

        <div className={styles.price}>{
          <PriceLine
            price={price.ShopItem(
              item.metadata,
              item.metadata.chosen_sub,
              item.metadata.chosen_addon,
              item.quantity
            )}
            promotion={site.data.promotion}
            priceClass={price}
          />
        }</div>

      </Col>

    </Row>
  );
};

Item.propTypes = {
  item: PropTypes.object,
  site: PropTypes.object
};

export default Item;



// WEBPACK FOOTER //
// ./src/components/front/Cart/Item.jsx